/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./ListItem.scss";

export default function ListItem({ kind, showMonetization, children, ...restProps }: any) {
  function icon() {
    if (kind === "highlight") return "check-curvy-small";
    if (kind === "warning") return "warning-hexagon";
    if (kind === "denied") return "cross-filled";
    return "check";
  }

  function classList() {
    if (kind === "highlight") return "list-item--highlight";
    if (kind === "warning") return "list-item--warning";
    if (kind === "denied") return "list-item--denied";
    return "";
  }

  return (
    <li
      {...restProps}
      className={cn("scope-eae00b23 list-item", classList(), restProps.className)}
      data-testid="list-item"
    >
      <UseSvg
        className={cn("list-item__icon scope-eae00b23", {
          "enable-ab-monetization-ui-v2": showMonetization
        })}
        icon={icon()}
        data-testid="list-item-icon"
      />
      <span className="scope-eae00b23">{children}</span>
    </li>
  );
}
